const pronouns = [
  {
    name: 'none',
    value: ' ',
  },
  {
    name: 'she/her/hers',
    value: 'she/her/hers',
  },
  {
    name: 'he/him/his',
    value: 'he/him/his',
  },
  {
    name: 'they/them/their',
    value: 'they/them/their',
  },
  {
    name: 'ze/zir/zirs',
    value: 'ze/zir/zirs',
  },
  {
    name: 'ze/hir/hirs',
    value: 'ze/hir/hirs',
  },
];
export default pronouns;
